
import { defineComponent } from 'vue';
import MainLayout from '@/layout/MainLayout.vue';
import { useGalleryStore } from '@/store/GalleriesStore';
import { useAuthStore } from '@/store/AuthStore';
import { UserRecord } from '@/dataTypes/types';
import Swal from 'sweetalert2';
import Help from '@/api/helpService';

export default defineComponent({
  components: { MainLayout },
  data() {
    const Help = useGalleryStore();
    const Auth = useAuthStore();
    return {
      Help,
      Auth,
      role: '',
      text: '',
      userInfo: null as UserRecord | null,
    };
  },
  methods: {
    async handleMessageSubmission(text: string) {
      if (this.role === 'gallery' || this.role === 'private_seller') {
        await this.Help.sendHelpMessage(this.role, text);
      } else if (this.role === 'artist') {
        await this.Help.sendHelpMessage(this.role, text);
      }
    },
    async sendHelpMessage(data: string) {
      const endpoints = {
        gallery: 'galleries',
        private_seller: 'private_sellers',
        artist: 'artists',
      };
      const endpoint = endpoints[this.role as keyof typeof endpoints];
      if (!endpoint) {
        Swal.fire({
          title: 'Error',
          text: 'There was an error sending your message.',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
        return;
      }

      try {
        const res = await Help.sendMessage(endpoint, data);
        if (res.success === true) {
          Swal.fire({
            title: 'Message Sent',
            text: 'Your message has been sent.',
            icon: 'success',
            confirmButtonText: 'Ok',
          });
          this.text = '';
        } else {
          Swal.fire({
            title: 'Error',
            text: 'There was an error sending your message.',
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  async created() {
    if (this.Auth.isLoggedIn) {
      this.userInfo = await this.Auth.fetchUserInfo();
      this.role = this.Auth.userRole;
    }
  },
});
